<script>
import PauseSceneLoggedIn from './PauseSceneLoggedIn.vue';
import CountdownTimerConnected from '@/launcher/components/connected/ui/CountdownTimerConnected.vue';
import LanguageButtonConnected from '@/launcher/components/connected/ui/LanguageButtonConnected.vue';
import HelpRequestedNotification from '@/launcher/components/shared/notifications/HelpRequestedNotification';
import CallHelpBtnConnected from '../connected/ui/CallHelpBtnConnected';

export default {
  name: 'PauseBox',
  components: {
    PauseSceneLoggedIn,
    CountdownTimerConnected,
    LanguageButtonConnected,
    HelpRequestedNotification,
    CallHelpBtnConnected,
  },
  props: {
    station: {
      type: Object,
      required: true,
    },
    // loading: {
    //   type: Boolean,
    //   required: true,
    // },
    hasCalledHelp: {
      type: Boolean,
      required: true,
    },
    timerStatus: {
      validator (val) { return typeof val === 'string' || val === null; },
      required: true,
    },
    // user: {
    //
    // },
  },
  computed: {
    // anonymous () {
    //   return this.user === 'anonymous'
    // },
  },
  methods: {
    launchTutorial () {
      this.$gtm.trackEvent({
        category: 'Tutorial',
        action: 'launch',
        label: '',
      });
      this.$emit('launch-tutorial');
    },
  },

};
</script>

<template lang="pug">
  div.pause-box.center.relative
    div.bg-black-overlay.relative(:class="timerStatus !== 'offline' ? '_collision' : ''")
      LanguageButtonConnected.languagebtn._collision
      header.header.cf.flex-auto.pt3.pb3(v-if="timerStatus !== 'infinite'")
        div.timeremaining.white.tc.pv2
          CountdownTimerConnected
      //- div.accountbox.mt3(v-if="user")
      //-   pause-scene-logged-in
    div.buttons.mt2
      //- template(v-if="!anonymous")
      //-   cta-style
      //-     launcher-router-link.tutorialbtn.shadow-5.b--black.bg-light-overlay.pa3.f6.w-100.db(:to="{ name: 'switchplayer' }") Switch player
      //- cta-style
      //-   button.tutorialbtn.b--black.bg-light-overlay.pa3.f6.w-100.db(type="button", @click="launchTutorial") {{ $t('Tutorial') }}
      //- cta-style
      //-   launcher-router-link.accountbtn.b--black.bg-light-overlay.pa3.f6.w-100.db(:to="{ name: 'signup' }") My account
      CallHelpBtnConnected.helpbtn.w-100.db.f6(:light="true")
    .helprequested.absolute.w-100
      HelpRequestedNotification(v-show="hasCalledHelp")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pause-box {
  width: 156px;
  & .helprequested {
    bottom: -4rem;
  }
  & .languagebtn {
    transform: translateX(-100%);
  }
}
</style>
